import React from "react";
import SigninPatientKatomi from "./Katomi";

const SigninPatient: React.FC = (props) => {
  return <SigninPatientKatomi {...props} />;
};

export default SigninPatient;
